import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { GlobalsService } from "@app/core/services";
import { themeUI } from "@app/core/utils/helpers";

export const appResolver: ResolveFn<boolean> = async (route, state) => {
  const globals: GlobalsService = inject(GlobalsService);
  try {
    globals.showsplash = true;
    themeUI()
    globals.showsplash = false;
    return true;
  } catch (error) {
    globals.showsplash = false;
    console.log(error)
    return false;
  }
};
